import React, { useState } from "react";
import Button from '../UI/Button';
import { Col, Row, Container } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { recoverPassGet, getVerify } from '../../api';
import Loading from '../Loading';
import { useHistory } from "react-router-dom";
import TextInput from '../UI/TextInput';
import { recoverPasswordNotice, userNotFoundNotice, somethingWentWrongNotice } from '../UI/Notifications';

const RecoverPassword = () => {
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const { register, handleSubmit, errors } = useForm();
  let urljoin = require('url-join');
  const querystring = require('querystring');

  const resetPasswordByEmail = () => {
    recoverPasswordNotice("Please check your email to reset your password.");
    setLoading(false);
  }

  const verification = (responseData) => {
    setLoading(true);
    const params = {
      user_id: responseData.user_id,
      hash_data: responseData.hash_data,
      link: `${window.origin}/user-verification-email`
    }

    getVerify(params)
      .then(() => {
        const queryString = querystring.stringify(params);
        setLoading(false);
        history.push(`/send-again-email?${queryString}`);
      })
      .catch(() => {
        somethingWentWrongNotice("Recover Password");
        setLoading(false);
      });
  }

  const onSubmit = (data, e) => {
    setLoading(true);
    e.preventDefault();
    e.target.reset();
    
    data.link = urljoin(window.location.href, "/set-password");

    recoverPassGet(data)
      .then(response => {
        resetPasswordByEmail();
      })
      .catch(error => {
        if (error.response.status === 404) {
          userNotFoundNotice();
          setLoading(false);
        }
        if (error.response.status === 401) verification(error.response);
        if (![401, 404].includes(error.response.status)) {
          somethingWentWrongNotice("Recover Password");
          setLoading(false);
        }
      });
  };

  return (
    <Container>
      <Row>
        <Col>
          <div className="form-wrap my-5">
            <h2 className="text-center mb-5">Recover Password</h2>
            <form onSubmit={handleSubmit(onSubmit)}>
              <fieldset>
                <label htmlFor="username_email">Username of Email <span>*</span></label>
                <TextInput 
                  name="username_email"
                  type="text"
                  register={register({ required: true })}
                  label="Email or Username"
                />
                {errors.username_email && (
                  <p className="warnMessage">This field is required</p>
                )}
              </fieldset>
              {loading && <Loading />}
              <Row className="mb-3">
                <Col className="text-center">
                  <Button 
                    type="submit"
                    width="w-100"
                    label="Send"
                  />
                </Col>
              </Row>
            </form>
          </div>
        </Col>
      </Row>
    </Container>
    
  )
}

export default RecoverPassword;